/* eslint-disable import/first */
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

import axios from 'axios';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/index';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/tooltip';
import 'toastr';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive';
import 'bootstrap-input-spinner/src/bootstrap-input-spinner';
import './apps/MegaMenu';
import './apps/Cart/CartBadge';
import AcceptedTerms from './apps/AcceptedTerms';
import AccessibleLink from './apps/AccessibleLink';
// import CallbackRequest from './apps/CTA/CallbackRequest';
import PrimarySearch from './apps/PrimarySearch';
import Ribbon from './apps/Ribbon';
import ScrollTop from './apps/ScrollTop';

axios.defaults.headers.common.pragma = 'no-cache';

// Footer Visszahívás kérése
// const callbackRequest = new CallbackRequest();

// Akadálymentes linkek
AccessibleLink.init();

// Accept terms
AcceptedTerms.init();

// Primary Search
const primarySearch = new PrimarySearch();

// Mobile ScrollTop
ScrollTop.init();

// Cart Badge
cartbadge.refreshWithAPI();

$(() => {
  // Ribbon
  const element = document.querySelector('#theRibbon');
  if (element !== null) {
    const ribbon = new Ribbon(element);
    ribbon.start();
  }

  // Tooltipp
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="tooltip-light"]').tooltip({
    template: '<div class="tooltip tooltip--light" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
  });
});

const numbers = Array.from(document.querySelectorAll('input [type="number"]'));
numbers.forEach((number) => {
  number.addEventListener('keypress', (e) => {
    const newValue = e.target.value + e.key;
    // eslint-disable-next-line no-mixed-operators
    if (Number.isNaN(newValue) && e.which !== 8 && e.which !== 17 && newValue[0] !== '-' || newValue[0] === '-' && Number.isNaN(newValue.slice(1))) { e.preventDefault(); } // Then don't write it!
  });
});
